import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import ReactCountryFlag from 'react-country-flag';

import styles from './MyPage.module.css';

export const CountrySelectComponent = ({ input, options, label, meta }: any) => {
  const { t } = useTranslation();
  return (
    <div>
      <label className={clsx(styles['select'])}>
        <select {...input}>
          <option value="">{label}</option>
          {options.map((option: any) => (
            <option key={option.key} value={option.key}>
              <ReactCountryFlag countryCode={option.key} />
              {option.text}
            </option>
          ))}
        </select>
      </label>
      {meta.touched && meta.error && (
        <p className={clsx(styles['message'], styles['message--err'])}>{t(`${meta.error}`)}</p>
      )}
    </div>
  );
};
